define(function (require, exports, module) {
    var BaseApiHeartbeatItem = require('./BaseApiHeartbeatItem');

    var Superclass;

    function PassiveApiRequestItem (gameID, gameItem) {
        Superclass.constructor.call(this, gameID, gameItem);
    }

    BaseApiHeartbeatItem.spawn(PassiveApiRequestItem).define({
        checkHeartbeat: function () {
            // No heartbeat ever
            // EVER!
            // So just pretend like we're all good.
            return true;
        }
    });

    Superclass = PassiveApiRequestItem.superclass;

    return PassiveApiRequestItem;
});
